import { useFormik } from 'formik';
import { t } from 'i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { getInitValuesSPV, SpvInfo, validationSchemaSPV } from 'src/components/issuer/forms/SpvInfo';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { useSPV } from 'src/hooks/useSPV';
import { Routes } from 'src/router/Routes';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Card, CardContent } from '@mui/material';
import { postSPVs, putSPVs } from '../../api/stoApi';
import { generalStore } from '../../stores/GeneralStore';
import { useEffect, useState } from 'react';
import { Alpha3Code } from 'i18n-iso-countries';

export const IssuerProfile = () => {
  const { spvId } = useParams();
  const navigate = useNavigate();
  const [reset, setReset] = useState(false);
  const spv = spvId ? useSPV(spvId, reset) : null;
  const [countryCode, setCountryCode] = useState<Alpha3Code | undefined>(undefined);
  const formikSPV = useFormik({
    enableReinitialize: true,
    initialValues: getInitValuesSPV(spv),
    validationSchema: validationSchemaSPV,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        generalStore.setIsLoading(true);
        if (spvId) {
          await putSPVs(spvId, values);
          generalStore.setInfoMsg(t('issuer.spv.updateSuccessMsg'));
          setReset(!reset);
        } else {
          await postSPVs(values);
          generalStore.setInfoMsg(t('issuer.spv.createSuccessMsg'));
          navigate(Routes.ISSUER.ROOT);
        }
      } catch (error: any) {
        generalStore.setError(t('issuer.spv.unkownError'));
      } finally {
        generalStore.setIsLoading(false);
      }
    },
  });
  useEffect(() => {
    setCountryCode(formikSPV.values.address?.countryCode);
  }, [formikSPV.values.address?.countryCode]);
  return (
    <>
      <SiteHeader
        breadcrumbs={[
          {
            link: Routes.ISSUER.ROOT,
            label: t('translation:issuer.overview.title'),
            icon: <PeopleAltIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
          {
            link: Routes.ISSUER.PROFILE,
            label: spvId ? spv?.companyName || '' : t('issuer.spv.add'),
          },
        ]}
        headline={spv?.companyName || ''}
      />
      <Card>
        <CardContent>{<SpvInfo formik={formikSPV} spvCountry={countryCode} isCreating={!spvId} />}</CardContent>
      </Card>
    </>
  );
};
